import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";

import { dateTimeConverter } from "../../../utils/dateConverters";
import { DateRender } from "../../DateRender";

import { calculateStatus } from "./utils";

interface AnalyticStatusChipProps {
  experience: ExperienceDto;
}

export const AnalyticStatusChip = ({ experience }: AnalyticStatusChipProps) => {
  if (experience.status === "pending" || experience.status === "ended") {
    return <div />;
  } else if (experience.status === "paused") {
    return (
      <IgTypography sx={{ fontSize: "15px" }}>
        Paused on <DateRender date={dateTimeConverter(experience.pausedAtTs)} />
      </IgTypography>
    );
  } else {
    return (
      <IgTypography sx={{ fontSize: "15px" }}>
        {calculateStatus(experience).label}
      </IgTypography>
    );
  }
};
